
import Search from 'vux/src/components/search/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'


export default {
components: {
Search,
Group,
Cell,
CellBox
},
data () {
return {
searchValue: '',
cityData: [],
placeData: []
};
},
computed: {
searchData () {
const self = this;
return self.placeData.filter(({name}) => name.indexOf(self.searchValue) !== -1);
}
},
created () {
this.loadData();
},
methods: {
loadData () {
const self = this;
self.$http.get('./static/phpapi/cityData.php')
.then((resp) => {
self.placeData = [];
self.cityData = resp.data.map((province) => {
province.show = province.show || false;
if (province.province) {
province.province = province.province.map((city) => {
city.show = false;
return city;
});
}
return province;
});

resp.data.forEach((province) => {
if (province.province) {
province.province.forEach((city) => {
self.placeData = self.placeData.concat(city.city);
});
}
});
});
},
handleSearch (val) {
this.searchValue = val;
}
}
};



// WEBPACK FOOTER //
// ./src/components/weather/CityList.vue